import Hero from './components/Hero';
import HotArticles from './components/HotArticles';
import LatestNews from './components/LatestNews';
import CategoryNav from './components/CategoryNav';
import ExclusiveSection from './components/ExclusiveSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <main>
      <Hero />
      <HotArticles />
      <LatestNews />
      <CategoryNav />
      <ExclusiveSection />
      <CTASection />
    </main>
  );
}